import { Component } from '@angular/core';
import {TipoAcao} from "../models/tipo-acao";
import {CadastrosGeraisService} from "../../services/cadastros-gerais.service";
import {ToastrService} from "ngx-toastr";
import Swal from "sweetalert2";

@Component({
    selector: 'app-tipo-acao',
    templateUrl: './tipo-acao.component.html',
    styleUrl: './tipo-acao.component.css',
    standalone: false
})
export class TipoAcaoComponent {
  loading = true;
  public colunas = ['Id', 'Descrição'];
  public linhas: any[] = [];
  listaTipoAcao: TipoAcao[] = [];
  tipoAcao = new TipoAcao();
  adicionar = false;

  paginaAtual = 1;

  constructor(private cadastrosGeraisService: CadastrosGeraisService,
              private toastrService: ToastrService) {
    this.buscarListaTipoAcao();
  }

  public pageChange(event: number){
    this.paginaAtual = event;
  }

  public showModal() {
    this.adicionar = true;
  }

  public fecharModal(){
    this.adicionar = false;
  }

  public salvar(){
    this.loading = true;
    this.cadastrosGeraisService.adicionarTipoAcao(this.tipoAcao).subscribe(resultado => {
      if(resultado.sucesso){
        this.toastrService.success("Tipo de ação adicionado com sucesso!");
        this.fecharModal();
        this.linhas = [];
        this.buscarListaTipoAcao();
      }
      else{
        this.toastrService.error(resultado.errors[0].mensagem);
      }
    }, error => {
      this.toastrService.error(error);
    });
    this.loading = false;
  }

  public desativar(id: number){
    this.loading = true;
    Swal.fire({
      title: 'Deseja realmente desativar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: '#fd7e14',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.cadastrosGeraisService.desativarTipoTipoAcoes(id).subscribe(resultado => {
          if(resultado.sucesso){
            this.toastrService.success("Desativado com sucesso");
            this.buscarListaTipoAcao();
          }
        })
      }
    });
    this.loading = false;
  }

  private buscarListaTipoAcao(): void {
    this.loading = true;
    this.cadastrosGeraisService.selecionarListaTipoAcoes().subscribe(response => {
      if(response.sucesso)
      {
        this.listaTipoAcao = [];
        this.listaTipoAcao = response.dados;
      }
    });
    this.loading = false;
  }
}
